import type { VoidFunctionComponent } from 'react';

import { type GenerateReportAction, GenerateReportButton } from '../components/GenerateReportButton';
import { useVulnerabilityDownloadReport } from '../hooks/useVulnerabilityDownloadReport';

/**
 * Vulnerability-specific generate button — download only (no public link, no email).
 * Reuses the shared GenerateReportButton presentational component.
 *
 * @deprecated The Security/Vulnerability report is a legacy surface gated by
 * the `SECURITY_PDF_REPORTS` feature flag. This report format is no longer
 * supported and is being phased out — do not add new functionality to this
 * component or extend its behaviour. New reporting work should target the
 * Remediation Guidance report (or successor) instead.
 */
export const VulnerabilityGenerateButton: VoidFunctionComponent = () => {
  const { downloadReport } = useVulnerabilityDownloadReport();

  const onItemClick = (action: GenerateReportAction) => {
    if (action === 'download') {
      downloadReport();
    }
  };

  return (
    <GenerateReportButton
      isLoading={false}
      shouldShowPublicLink={false}
      shouldShowDownload
      shouldShowEmail={false}
      onItemClick={onItemClick}
    />
  );
};
